export const routing = {
  locales: ["it", "en"] as const,
  defaultLocale: "it" as const,
};

export type Locale = (typeof routing.locales)[number];
